<template>
  <div>
    <el-form
      :model="list"
      :rules="toAdRule"
      label-position="right"
      label-width="200px"
      ref="ruleForm"
      style="width: 90%; margin: 20px auto"
    >
      <el-row>
        <el-col :span="10" style="padding-left:135px">
          <el-checkbox v-model="list.isRenqi" :false-label="0" :true-label="1"
            >人气</el-checkbox
          >
          <el-checkbox v-model="list.isResou" :false-label="0" :true-label="1"
            >热搜</el-checkbox
          >
          <el-checkbox v-model="list.isKoubei" :false-label="0" :true-label="1"
            >口碑</el-checkbox
          >
        </el-col>
        <el-col :span="10">
          <el-form-item label="热搜排序" prop="resouSort">
            <el-input placeholder="请输入" v-model="list.resouSort"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="人气排序" prop="renqiSort">
            <el-input placeholder="请输入" v-model="list.renqiSort"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="口碑排序" prop="koubeiSort">
            <el-input placeholder="请输入" v-model="list.koubeiSort"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-button
          style="margin-left: 200px"
          type="primary"
          @click="submitAdd('ruleForm')"
          >保存</el-button
        >
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ["ChangeData"],
  data() {
    return {
      loadUpt: false, //加载
      list: "",
      //留言类型--下拉框：
      type: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],

      toAdRule: {
        isResou: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        isKoubei: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        isRenqi: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        renqiSort: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        koubeiSort: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        resouSort: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.list = this.ChangeData;
  },
  watch: {
    ChangeData(newVal, oldVal) {
      this.list = newVal;
    },
  },
  methods: {
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/floorSearch/update", {
            isResou: this.list.isResou,
            isRenqi: this.list.isRenqi,
            isKoubei: this.list.isKoubei,
            resouSort: this.list.resouSort,
            renqiSort: this.list.renqiSort,
            koubeiSort: this.list.koubeiSort,
            floorId: this.list.floorId,
            id: this.list.id,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .el-checkbox{
  margin-right:55px !important
}
</style>